    angular.module('lead-buffer', ['core', 'lead'])
        .factory('LeadBufferIntegration', function ($resource) {
            return  $resource('/crm/api/lead-buffer-integration/:name', {name: "@name"}, {
                records: {method: 'GET', isArray: false, url: '/crm/api/lead-buffer-integration/:type'},
                statistics: { method: 'GET', isArray: true, url: '/crm/api/lead-buffer-integration/statistics' },
            });
        })
        .component('leadBufferIntegrationList', {
            bindings: {
                filters: '<',
                page: '<'
            },
            templateUrl: ($stateParams) => 'app/lead/buffer/list-' + $stateParams.type + '.html',
            controller: function ($scope, $state, $stateParams, toastr, modals, Lead, LeadService, LeadBufferIntegration, PhoneNumberFormatter) {
                const ESTI_FORMATS = ['YYYY-MM-DDTHH:mm:ss', 'YYYY-MM-DDTHH:mm:ss.SSS', 'YYYY-MM-DDTHH:mm:ss[Z]', 'YYYY-MM-DDTHH:mm:ss.SSS[Z]'];
                const CALLPAGE_FORMATS = ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm'];
                const MORIZON_FORMATS = ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DDTHH:mm:ss'];

                let parseUtcToLocal = (value, format) => {
                    if (!value) {
                        return null;
                    }
                    let parsed = moment.utc(value, format, true);
                    return parsed.isValid() ? parsed.local() : null;
                };
                let parseLocal = (value, format) => {
                    if (!value) {
                        return null;
                    }
                    let parsed = moment(value, format, true);
                    return parsed.isValid() ? parsed : null;
                };
                let isValidMoment = datetime => datetime && datetime.isValid && datetime.isValid();
                let toLeadDate = datetime => isValidMoment(datetime) ? datetime.format('YYYY-MM-DD') : null;
                let toLeadTime = datetime => isValidMoment(datetime) ? datetime.format('HH:mm:ss') : null;
                let toDisplay = datetime => isValidMoment(datetime) ? datetime.format('YYYY-MM-DD HH:mm:ss') : null;
                let normalizePhone = phone => PhoneNumberFormatter.normalizeForCompare(phone) || phone || null;
                let normalizeEmail = email => email ? String(email).trim().toLowerCase() : null;
                let normalizeEstiDateTime = value => parseLocal(value, ESTI_FORMATS);
                let normalizeCallPageDateTime = value => parseLocal(value, CALLPAGE_FORMATS);
                let normalizeMorizonDateTime = value => parseLocal(value, MORIZON_FORMATS);
                let normalizeEasyFormsDateTime = value => parseUtcToLocal(value, moment.ISO_8601);
                let normalizeBufferDateTime = value => {
                    if (!value) {
                        return null;
                    }
                    let parsed = moment(value, [
                        'YYYY-MM-DDTHH:mm:ss',
                        'YYYY-MM-DDTHH:mm:ss.SSS',
                        'YYYY-MM-DDTHH:mm:ssZ',
                        'YYYY-MM-DDTHH:mm:ss.SSSZ',
                        'YYYY-MM-DD HH:mm:ss',
                        'YYYY-MM-DD HH:mm'
                    ], true);
                    return parsed.isValid() ? parsed : null;
                };
                let normalizeEasyFormsKey = value => String(value || '').trim().toLowerCase()
                    .replace(/ł/g, 'l')
                    .replace(/ó/g, 'o')
                    .replace(/ą/g, 'a')
                    .replace(/ę/g, 'e')
                    .replace(/ś/g, 's')
                    .replace(/ć/g, 'c')
                    .replace(/ń/g, 'n')
                    .replace(/[żź]/g, 'z')
                    .replace(/[^a-z0-9]+/g, '_');
                let findEasyFormsAnswer = (item, ...keys) => {
                    let normalizedKeys = keys.map(normalizeEasyFormsKey);
                    let answer = (item.answers || []).find(candidate => {
                        let key = normalizeEasyFormsKey(candidate.alias || candidate.name || candidate.label);
                        return key && normalizedKeys.some(expected => key.includes(expected));
                    });
                    return answer?.answer == null ? null : String(answer.answer).trim() || null;
                };

                this.LeadService = LeadService;
                this.automaticLeadCreating = {};
                this.formatEstiDateTime = value => toDisplay(normalizeEstiDateTime(value));
                this.formatCallPageDateTime = value => toDisplay(normalizeCallPageDateTime(value));

                this.addLeadEstiCrm = item => {
                    let acquisitionDateTime = normalizeEstiDateTime(item.create_date);
                    let data = {
                        externalSource: {
                            system: 'ESTICRM/RP',
                            id: item.pk
                        },
                        acquisitionDate: toLeadDate(acquisitionDateTime),
                        acquisitionTime: toLeadTime(acquisitionDateTime),
                    }
                    let phone = item.phone;
                    if(phone?.slice(0, 3) === '+48'){
                        phone = phone.slice(3)
                    }
                    if(phone?.slice(0, 2) === '48'){
                        phone = phone.slice(2)
                    }
                    let suggestion = {
                        name: item.name,
                        email: item.email,
                        phone: phone,
                        notes: item.content,
                        request: item.source.name,
                        property_project: item.offer_name,
                        property_number: item.property_number,
                        rawPayload: item.payload || item
                    }
                    LeadService.addSuggest(data, suggestion);
                }
                this.addLeadMorizon = item => {
                    let acquisitionDateTime = normalizeMorizonDateTime(item.addedAt);
                    let customer = item.customer || {};
                    let name = [customer.firstName, customer.surname].filter(Boolean).join(' ') || null;
                    let data = {
                        externalSource: {
                            system: 'MORIZON',
                            id: item.id
                        },
                        acquisitionDate: toLeadDate(acquisitionDateTime),
                        acquisitionTime: toLeadTime(acquisitionDateTime)
                    };
                    let suggestion = {
                        name: name,
                        email: customer.email || null,
                        phone: normalizePhone(customer.phone || customer.mobile),
                        notes: item.message || null,
                        request: 'Morizon',
                        property_project: item.developmentName || null,
                        property_number: item.propertyReference || null,
                        rawPayload: angular.copy(item)
                    };
                    LeadService.addSuggest(data, suggestion);
                }
                this.addLeadEasyForms = item => {
                    let acquisitionDateTime = normalizeEasyFormsDateTime(item.created_at);
                    let data = {
                        externalSource: {
                            system: 'EASYFORMS',
                            id: item.id
                        },
                        acquisitionDate: toLeadDate(acquisitionDateTime),
                        acquisitionTime: toLeadTime(acquisitionDateTime)
                    };
                    let suggestion = {
                        name: findEasyFormsAnswer(item, 'name', 'imie', 'imię', 'nazwisko', 'fullname', 'full_name'),
                        email: normalizeEmail(findEasyFormsAnswer(item, 'email', 'e-mail', 'mail')),
                        phone: normalizePhone(findEasyFormsAnswer(item, 'phone', 'telefon', 'tel', 'mobile')),
                        request: findEasyFormsAnswer(item, 'source', 'zrodlo', 'źródło', 'request'),
                        notes: findEasyFormsAnswer(item, 'message', 'wiadomosc', 'wiadomość', 'content', 'notes'),
                        property_project: findEasyFormsAnswer(item, 'project', 'projekt', 'investment', 'inwestycja'),
                        property_number: findEasyFormsAnswer(item, 'product', 'property', 'lokal', 'mieszkanie', 'property_number'),
                        rawPayload: angular.copy(item)
                    };
                    LeadService.addSuggest(data, suggestion);
                }
                this.createLeadMorizonAuto = item => {
                    let acquisitionDateTime = normalizeMorizonDateTime(item.addedAt);
                    let customer = item.customer || {};
                    let name = [customer.firstName, customer.surname].filter(Boolean).join(' ') || null;
                    return this.createAutomaticLead({
                        sourceSystem: 'MORIZON',
                        externalId: item.id,
                        acquisitionDate: toLeadDate(acquisitionDateTime),
                        acquisitionTime: toLeadTime(acquisitionDateTime),
                        sourceName: name,
                        sourceEmail: normalizeEmail(customer.email),
                        sourcePhone: normalizePhone(customer.phone || customer.mobile),
                        sourceRequest: 'Morizon',
                        sourceMessage: item.message || null,
                        sourceProject: item.developmentName || null,
                        sourcePropertyNumber: item.propertyReference || null,
                        rawPayload: angular.copy(item)
                    }, item.id);
                }
                this.createLeadEstiCrmAuto = item => {
                    let acquisitionDateTime = normalizeEstiDateTime(item.create_date);
                    return this.createAutomaticLead({
                        sourceSystem: 'ESTICRM/RP',
                        externalId: item.pk,
                        acquisitionDate: toLeadDate(acquisitionDateTime),
                        acquisitionTime: toLeadTime(acquisitionDateTime),
                        sourceName: item.name || null,
                        sourceEmail: normalizeEmail(item.email),
                        sourcePhone: normalizePhone(item.phone),
                        sourceRequest: item.source?.name || null,
                        sourceMessage: item.content || null,
                        sourceProject: item.offer_name || null,
                        sourcePropertyNumber: item.property_number || null,
                        rawPayload: angular.copy(item.payload || item)
                    }, item.pk);
                }
                this.addLeadCallPageV3 = item => {
                    let acquisitionDateTime = normalizeCallPageDateTime(item.createdAt);
                    let data = {
                        externalSource: {
                            system: 'CALLPAGE',
                            id: item.id
                        },
                        acquisitionDate: toLeadDate(acquisitionDateTime),
                        acquisitionTime: toLeadTime(acquisitionDateTime),
                    }
                    if(item.utm != null && (item.utm.utm_source || item.utm.utm_medium || item.utm.utm_campaign || item.utm.utm_term || item.utm.utm_content)){
                        data.utm = {
                            utm_source: item.utm.utm_source,
                            utm_medium: item.utm.utm_medium,
                            utm_campaign: item.utm.utm_campaign,
                            utm_term: item.utm.utm_term,
                            utm_content: item.utm.utm_content
                        }
                    }
                    let phone = item.phoneNumber;
                    if(phone?.slice(0, 3) === '+48'){
                        phone = phone.slice(3)
                    }
                    if(phone?.slice(0, 2) === '48'){
                        phone = phone.slice(2)
                    }
                    let suggestion = {
                        phone: phone,
                        email: item.fields?.email !== null? item.fields.email : null,
                        name: item.fields?.name !== null? item.fields.name : null,
                        rawPayload: item.payload || item
                    }
                    LeadService.addSuggest(data, suggestion);
                }
                this.createLeadCallPageAuto = item => {
                    let acquisitionDateTime = normalizeCallPageDateTime(item.createdAt);
                    let payload = {
                        sourceSystem: 'CALLPAGE',
                        externalId: item.id,
                        acquisitionDate: toLeadDate(acquisitionDateTime),
                        acquisitionTime: toLeadTime(acquisitionDateTime),
                        sourceName: item.fields?.name || null,
                        sourceEmail: normalizeEmail(item.fields?.email),
                        sourcePhone: normalizePhone(item.phoneNumber),
                        sourceRequest: this.callPageSource(item),
                        sourceMessage: this.callPageMessage(item),
                        rawPayload: angular.copy(item.payload || item)
                    };
                    if(item.utm != null && (item.utm.utm_source || item.utm.utm_medium || item.utm.utm_campaign || item.utm.utm_term || item.utm.utm_content)){
                        payload.utm = {
                            utm_source: item.utm.utm_source,
                            utm_medium: item.utm.utm_medium,
                            utm_campaign: item.utm.utm_campaign,
                            utm_term: item.utm.utm_term,
                            utm_content: item.utm.utm_content
                        }
                    }
                    return this.createAutomaticLead(payload, item.id);
                }
                this.addLeadBufferLocal = item => {
                    let acquisitionDateTime = normalizeBufferDateTime(item.createdTime);
                    let data = {
                        externalSource: {
                            system: 'BUFFER',
                            id: item.id
                        },
                        acquisitionDate: toLeadDate(acquisitionDateTime),
                        acquisitionTime: toLeadTime(acquisitionDateTime),
                    }
                    if(item.payload.utm_source || item.payload.utm_medium || item.payload.utm_campaign || item.payload.utm_term || item.payload.utm_content){
                        data.utm = {
                            utm_source: item.payload.utm_source,
                            utm_medium: item.payload.utm_medium,
                            utm_campaign: item.payload.utm_campaign,
                            utm_term: item.payload.utm_term,
                            utm_content: item.payload.utm_content
                        }
                    }
                    let phone = item.payload.phone;
                    if(phone?.slice(0, 3) === '+48'){
                        phone = phone.slice(3)
                    }
                    if(phone?.slice(0, 2) === '48'){
                        phone = phone.slice(2)
                    }
                    let suggestion = {
                        name: item.payload.name,
                        email: item.payload.email,
                        phone: phone,
                        notes: item.payload.message,
                        property_number: item.payload.product,
                        request: item.payload.source,
                        privacy_policy: item.payload.privacy_policy,
                        privacy_policy_text: item.payload.privacy_policy_text,
                        personal_data_processing: item.payload.personal_data_processing,
                        personal_data_processing_text: item.payload.personal_data_processing_text,
                        direct_marketing_using_telco_equipment: item.payload.direct_marketing_using_telco_equipment,
                        direct_marketing_using_telco_equipment_text: item.payload.direct_marketing_using_telco_equipment_text,
                        receipt_of_commercial_information: item.payload.receipt_of_commercial_information,
                        receipt_of_commercial_information_text: item.payload.receipt_of_commercial_information_text,
                        receiving_commercials: item.payload.receiving_commercials,
                        receiving_commercials_text: item.payload.receiving_commercials_text,
                        profiling_personal_data_for_marketing: item.payload.profiling_personal_data_for_marketing,
                        profiling_personal_data_for_marketing_text: item.payload.profiling_personal_data_for_marketing_text,
                        rawPayload: item.payload
                    }
                    LeadService.addSuggest(data, suggestion);
                }
                this.createLeadBufferAuto = item => {
                    let acquisitionDateTime = normalizeBufferDateTime(item.createdTime);
                    let payload = {
                        sourceSystem: 'BUFFER',
                        externalId: item.id,
                        acquisitionDate: toLeadDate(acquisitionDateTime),
                        acquisitionTime: toLeadTime(acquisitionDateTime),
                        sourceName: item.payload.name || null,
                        sourceEmail: normalizeEmail(item.payload.email),
                        sourcePhone: normalizePhone(item.payload.phone),
                        sourceRequest: item.payload.source || null,
                        sourceMessage: item.payload.message || null,
                        sourcePropertyNumber: item.payload.product || null,
                        rawPayload: angular.copy(item.payload)
                    };
                    if(item.payload.utm_source || item.payload.utm_medium || item.payload.utm_campaign || item.payload.utm_term || item.payload.utm_content){
                        payload.utm = {
                            utm_source: item.payload.utm_source,
                            utm_medium: item.payload.utm_medium,
                            utm_campaign: item.payload.utm_campaign,
                            utm_term: item.payload.utm_term,
                            utm_content: item.payload.utm_content
                        }
                    }
                    return this.createAutomaticLead(payload, item.id);
                }

                this.createAutomaticLead = (payload, sourceId) => {
                    if (this.isAutomaticLeadCreating(sourceId)) {
                        return;
                    }
                    this.automaticLeadCreating[sourceId] = true;
                    return modals.confirm("Czy automatycznie utworzyć lead z rekordu #" + sourceId + "?", () =>
                        Lead.createAutomatic(payload).$promise.then(lead => {
                            toastr.success("Utworzono lead #" + lead.id);
                            $state.reload();
                            if (lead.id) {
                                LeadService.show(lead.id);
                            }
                        }).catch(rejection => {
                            toastr.error(rejection?.data?.message || "Nie udało się utworzyć leada automatycznie");
                        })
                    ).finally(() => delete this.automaticLeadCreating[sourceId]);
                }

                this.isAutomaticLeadCreating = sourceId => !!this.automaticLeadCreating[sourceId];

                this.callPageSource = item => {
                    return item.leadable?.description || item.leadable?.type || item.leadable?.id || null;
                }

                this.callPageMessage = item => {
                    let lines = [];
                    let callRecipient = this.normalizeCallPageUserName(item.user?.name);
                    let billingTime = Number(item.call?.billingTime || 0);
                    let summary;
                    if (billingTime <= 0) {
                        summary = "Próba kontaktu";
                    } else if (callRecipient) {
                        summary = "Rozmowa z " + callRecipient;
                    } else {
                        summary = "Rozmowa telefoniczna";
                    }
                    if (billingTime > 0) {
                        summary += ", " + billingTime + " sek.";
                        if (item.call?.id != null) {
                            lines.push("ID rozmowy: " + item.call.id);
                        }
                    }
                    lines.unshift(summary);
                    return lines.length > 0 ? lines.join("\n") : null;
                }

                this.normalizeCallPageUserName = value => (value || '').replace(/^['"\s]+|['"\s]+$/g, '').trim();

                this.durationFormat = duration => {
                    return moment.utc(moment.duration(duration, "seconds").asMilliseconds()).format("mm:ss")
                }

                this.reload = () => $state.reload();

                this.reset = () => this.filters = {};

                $scope.$on('lead.updated', () => $state.reload());
                $scope.$on('lead.deleted', () => $state.reload());
            }
        })
        .config(function ($stateProvider) {
            $stateProvider.state('leadBufferIntegrationList', {
                parent: 'app',
                url: '/lead-buffer-integration/{type}?{page:int}&periodStart&periodEnd&processed',
                params: {
                    periodStart: {
                        value: moment().subtract(14, 'days').format('YYYY-MM-DD'),
                    },
                    periodEnd: {
                        value: moment().add(14, 'days').format('YYYY-MM-DD'),
                    }
                },
                data: {
                    authorities: ['ROLE_LEADS_INTEGRATIONS']
                },
                views: {
                    'content@': 'leadBufferIntegrationList'
                },
                resolve: {
                    filters: $stateParams => angular.copy($stateParams),
                    page: (LeadBufferIntegration, $stateParams) => LeadBufferIntegration.records(angular.copy($stateParams)).$promise
                }
            });
        });
